import React from "react"
import logo from "../../../assets/img/logo/logo.png"
import logosalehunter from "../../../assets/img/logo/logo-salehunter.png"
import "../../../assets/scss/components/app-loader.scss"
import { getDomainInfo } from "../../../client"
class SpinnerComponent extends React.Component {
	render() {
		return (
			<div className="fallback-spinner vh-100">
				<img className="fallback-logo" src={getDomainInfo().rootDomain === "salehunter.io" ? logosalehunter : logo} alt="logo" />
				<div className="loading">
					<div className="effect-1 effects"></div>
					<div className="effect-2 effects"></div>
					<div className="effect-3 effects"></div>
				</div>
			</div>
		)
	}
}

export default SpinnerComponent
